export const transitionsLens = [
  {
    name: 'GenS',
    colors: [
      { colorCode: 'GENS-AMBER', colorName: 'Amber' },
      { colorCode: 'GENS-RUBY', colorName: 'Ruby' },
      { colorCode: 'GENS-AMETHYST', colorName: 'Amethyst' },
      { colorCode: 'GENS-EMERALD', colorName: 'Emerald' },
      { colorCode: 'GENS-GRAY', colorName: 'Gray' },
      { colorCode: 'GENS-SAPPHIRE', colorName: 'Sapphire' },
      { colorCode: 'GENS-BROWN', colorName: 'Brown' },
      { colorCode: 'GENS-GGREEN', colorName: 'Graphite Green' },
    ],
  },
  {
    name: 'Xtractive',
    colors: [
      { colorCode: 'XTRACTIVE-NEWGEN-BLUE-MIRROR', colorName: 'Blue Mirror' },
      { colorCode: 'XTRACTIVE-NEWGEN-BROWN', colorName: 'Brown' },
      { colorCode: 'XTRACTIVE-NEWGEN-GREEN', colorName: 'Green' },
      { colorCode: 'XTRACTIVE-GOLD-MIRROR', colorName: 'Gold Mirror' },
      { colorCode: 'XTRACTIVE-NEWGEN-GRAY', colorName: 'Gray' },
      { colorCode: 'XTRACTIVE-NEWGEN-GREEN-MIRROR', colorName: 'Green Mirror' },
      { colorCode: 'XTRACTIVE-PINK-MIRROR', colorName: 'Pink Mirror' },
      { colorCode: 'XTRACTIVE-RED-MIRROR', colorName: 'Red Mirror' },
      { colorCode: 'XTRACTIVE-SILVER-MIRROR', colorName: 'Silver Mirror' },
    ],
  },
  {
    name: 'Xtractive Polarized',
    colors: [{ colorCode: 'XTRACTIVE-VANTAGE-POLARIZED', colorName: 'Gray' }],
  },
  {
    name: 'Signature Gen8',
    colors: [
      { colorCode: 'SIGNATURE-GEN8-AMBER', colorName: 'Amber' },
      { colorCode: 'SIGNATURE-GEN8-AMETHYST', colorName: 'Amethyst' },
      { colorCode: 'SIGNATURE-GEN8-BROWN', colorName: 'Brown' },
      { colorCode: 'SIGNATURE-GEN8-EMERALD', colorName: 'Emerald' },
      { colorCode: 'SIGNATURE-GEN8-GRAY', colorName: 'Gray' },
      { colorCode: 'SIGNATURE-GEN8-GGREEN', colorName: 'Green' },
      { colorCode: 'SIGNATURE-GEN8-SAPPHIRE', colorName: 'Sapphire' },
    ],
  },
]
